export default "assets/images/flags/us-c7254180.svg";